import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, startWith, mapTo, distinctUntilChanged } from 'rxjs/operators';
import { of, interval } from 'rxjs';
import { MenuService } from 'src/app/service/http/menu/menu.service';
import { GetMenu, EMenuActions, GetMenuSuccess } from '../actions/menu.actions';
import { IMenu } from 'src/app/models/menu.interface';
import { PageLoadingHide, PageLoadingMenuHide } from '../actions/page.actions';

@Injectable()
export class MenuEffects {
  
  getMenu$ = createEffect(() => this._actions$.pipe(
    ofType<GetMenu>(EMenuActions.GetMenu),
    switchMap((action) => interval(30000).pipe(startWith(0), mapTo(action))),
    switchMap((action) => this._menuService.getRaces(action.payload)),
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    switchMap((menu: IMenu) => {
      return of(new GetMenuSuccess(menu), new PageLoadingMenuHide());
    })
  ));

  constructor(private _menuService: MenuService, private _actions$: Actions) {}
}
